<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="title">{{ __('error_report_form.title') }}</h2>
                <span v-if="!this.$props.loggedin">{{ __('error_report_form.subtitle') }}</span>
            </div>
        </div>
        <form method="post" :action="loginurl" @submit.prevent="onSubmit" v-if="!this.$props.loggedin">
            <input type="hidden" name="_token" :value="csrf">
            <div class="row">
                <div class="col-6">
                    <label class="required">{{ __('error_report_form.email') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('email') ? 'is-invalid' : '']"
                        type="email"
                        v-model="email"
                        name="email"
                        v-validate="'required|email'"
                        :data-vv-as="__('error_report_form.email')"><br>
                    <div class="invalid-feedback" v-if="errors.has('email')" v-text="errors.first('email')"></div><br>
                    <a href="/register" class="btn-green dark-border rounded">Regisztrálok</a>
                    <a href="/password/reset" class="default btn-gray rounded">Elfelejtett jelszó</a>
                </div>
                <div class="col-6">
                    <label class="required">{{ __('error_report_form.password') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('password') ? 'is-invalid' : '']"
                        type="password"
                        v-model="password"
                        name="password"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.password')"><br>
                    <div class="invalid-feedback" v-if="errors.has('password')" v-text="errors.first('password')"></div>
                    <button class="btn login-button" type="submit">{{ __('error_report_form.login') }}</button>
                </div>
            </div>
        </form>
        <div v-else>
            <div class="row title-row">
                <div class="col-12">
                    <h3 class="title">{{ __('error_report_form.my_data') }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.name') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('name') ? 'is-invalid' : '']"
                        type="text"
                        v-model="name"
                        name="name"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.name')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('name')" v-text="errors.first('name')"></div>
                </div>
            </div>
            <div class="row title-row">
                <div class="col-12">
                    <h3 class="title">{{ __('error_report_form.product_address') }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.postcode') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('postcode') ? 'is-invalid' : '']"
                        type="text"
                        v-model="postcode"
                        name="postcode"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.postcode')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('postcode')" v-text="errors.first('postcode')"></div>
                </div>
                <div class="col-6">
                    <label>{{ __('error_report_form.city') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('city') ? 'is-invalid' : '']"
                        type="text"
                        v-model="city"
                        name="city"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.city')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('city')" v-text="errors.first('city')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.address') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('address') ? 'is-invalid' : '']"
                        type="text"
                        v-model="address"
                        name="address"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.address')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('address')" v-text="errors.first('address')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.phone') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('phone') ? 'is-invalid' : '']"
                        type="text"
                        v-model="phone"
                        name="phone"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.phone')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('phone')" v-text="errors.first('phone')"></div>
                </div>
                <div class="col-6">
                    <label>{{ __('error_report_form.email') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('email') ? 'is-invalid' : '']"
                        type="text"
                        v-model="email"
                        name="email"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.email')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('email')" v-text="errors.first('email')"></div>
                </div>
            </div>
            <div class="row title-row">
                <div class="col-12">
                    <h3 class="title">{{ __('error_report_form.product') }}</h3>
                </div>
            </div>
            <div class="row" v-for="(item, index) in products" style="border-bottom: 2px solid black">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                            <label>{{ __('error_report_form.brand') }}</label><br>
                            <select class="form-control"
                                    :class="[errors.has(index+'_brand') ? 'is-invalid' : '']"
                                    v-model="item.brand"
                                    :name="index+'_brand'"
                                    v-validate="'required'"
                                    :data-vv-as="__('error_report_form.brand')"
                                    @change="brandSelected(item, item.brand)">
                                <option v-for="brand in brands" :value="brand.id">{{ brand.translations[0].name }}</option>
                                <option value="other">{{ __('error_report_form.other') }}</option>
                            </select>
                            <input class="form-control"
                                   :class="[errors.has(index+'_brand_other') ? 'is-invalid' : '']"
                                   type="text"
                                   v-model="item.otherBrand"
                                   :name="index+'_brand_other'"
                                   v-if="item.brand=='other'"
                                   style="margin-top: 10px;"
                                   v-validate="'required'"
                                   :data-vv-as="__('error_report_form.brand')">
                            <div class="invalid-feedback" v-if="errors.has(index+'_brand')" v-text="errors.first(index+'_brand')"></div>
                            <div class="invalid-feedback" v-if="errors.has(index+'_brand_other')" v-text="errors.first(index+'_brand_other')"></div>
                        </div>
                        <div class="col-6">
                            <label>{{ __('error_report_form.model') }}</label><br>
                            <select class="form-control"
                                    :class="[errors.has(index+'_model') ? 'is-invalid' : '']"
                                    v-model="item.model"
                                    v-if="item.brand != 'other'"
                                    :name="index+'_model'"
                                    v-validate="'required'"
                                    :data-vv-as="__('error_report_form.model')">
                                <option v-for="(id, model) in item.models" :value="id">{{ model }}</option>
                                <option value="other">{{ __('error_report_form.other') }}</option>
                            </select>
                            <input class="form-control"
                                   :class="[errors.has(index+'_model_other') ? 'is-invalid' : '']"
                                   type="text"
                                   :name="index+'_model_other'"
                                   v-model="item.otherModel"
                                   v-if="item.model=='other' || item.brand=='other'"
                                   v-validate="'required'"
                                   :data-vv-as="__('error_report_form.model')">
                            <div class="invalid-feedback" v-if="errors.has(index+'_model')" v-text="errors.first(index+'_model')"></div>
                            <div class="invalid-feedback" v-if="errors.has(index+'_model_other')" v-text="errors.first(index+'_model_other')"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <label>{{ __('error_report_form.serial_number') }}</label><br>
                            <input
                                class="form-control"
                                :class="[errors.has(index+'_serialNumber') ? 'is-invalid' : '']"
                                type="text"
                                v-model="item.serialNumber"
                                :name="index+'_serialNumber'"
                                v-validate="'required'"
                                :data-vv-as="__('error_report_form.serial_number')">
                            <div class="invalid-feedback" v-if="errors.has(index+'_serialNumber')" v-text="errors.first(index+'_serialNumber')"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label>{{ __('error_report_form.description') }}</label><br>
                            <textarea
                                class="form-control"
                                :class="[errors.has(index+'_description') ? 'is-invalid' : '']"
                                v-model="item.description"
                                v-validate="'required'"
                                :name="index+'_description'"
                                :data-vv-as="__('error_report_form.description')"
                                :placeholder="__('error_report_form.description_placeholder')"></textarea>
                            <div class="invalid-feedback" v-if="errors.has(index+'_description')" v-text="errors.first(index+'_description')"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <UploadImages :uploadMsg=" __('error_report_form.upload_msg')" :clearAll=" __('error_report_form.clear_all')" @changed="handleImages($event, item)"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a class="btn" style="background-color: #ffb307; color: white; font-weight: bold" @click="deleteProduct(index)">{{ __('error_report_form.delete') }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a class="btn" style="background-color: #ffb307; color: white; font-weight: bold" @click="addProduct()">
                        {{ (this.products.length == 0) ? __('error_report_form.select_product') : __('error_report_form.select_another_product') }}
                    </a>
                </div>
            </div>
            <div class="row title-row">
                <div class="col-12">
                    <h3 class="title">{{ __('error_report_form.billing_data') }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.billing_name') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('billingName') ? 'is-invalid' : '']"
                        type="text"
                        v-model="billingName"
                        name="billingName"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.billing_name')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('billingName')" v-text="errors.first('billingName')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.postcode') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('billingPostcode') ? 'is-invalid' : '']"
                        type="text"
                        v-model="billingPostcode"
                        name="billingPostcode"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.postcode')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('billingPostcode')" v-text="errors.first('billingPostcode')"></div>
                </div>
                <div class="col-6">
                    <label>{{ __('error_report_form.city') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('billingCity') ? 'is-invalid' : '']"
                        type="text"
                        v-model="billingCity"
                        name="billingCity"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.city')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('billingCity')" v-text="errors.first('billingCity')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.address') }}</label><br>
                    <input
                        class="form-control"
                        :class="[errors.has('billingAddress') ? 'is-invalid' : '']"
                        type="text"
                        v-model="billingAddress"
                        name="billingAddress"
                        v-validate="'required'"
                        :data-vv-as="__('error_report_form.address')"
                    >
                    <div class="invalid-feedback" v-if="errors.has('billingAddress')" v-text="errors.first('billingAddress')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-5">
                    <label class="custom-checkbox">
                        <p class="mb-0 black w-100">{{ __('error_report_form.courier') }}</p>
                        <input type="checkbox"
                               name="under40kg"
                               v-model="under40kg"
                               :data-vv-as="__('error_report_form.courier')"
                        >
                        <span class="checkmark" :class="[errors.has('under40kg') ? 'is-invalid' : '']"></span>
                        <div class="invalid-feedback" v-if="errors.has('under40kg')" v-text="errors.first('under40kg')"></div>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="custom-checkbox">
                        <p class="mb-0 black w-100"><a :href="this.$props.gdpr" target="_blank" :title="__('error_report_form.accept_tos')">{{ __('error_report_form.accept_tos') }}</a> <sup class="text-danger">*</sup></p>
                        <input type="checkbox"
                               name="policy"
                               v-model="policy"
                               v-validate="'required'"
                               :data-vv-as="__('error_report_form.accept_tos')"
                        >
                        <span class="checkmark" :class="[errors.has('policy') ? 'is-invalid' : '']"></span>
                        <div class="invalid-feedback" v-if="errors.has('policy')" v-text="errors.first('policy')"></div>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: center">
                    <a class="btn" style="background-color: #ffb307; color: white; font-weight: bold" @click="save">{{ __('error_report_form.save') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UploadImages from "vue-upload-drop-images"
import VeeValidate from 'vee-validate';
import Vue from "vue";
Vue.use(VeeValidate);

export default {
    name: "ErrorReporter",
    props: ['loggedin', 'gdpr', 'product', 'loginurl', 'successUrl'],
    components: {
        UploadImages,
    },

    inject: ['$validator'],

    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            email: '',
            password: '',
            name: '',
            city: '',
            phone: '',
            postcode: '',
            house: '',
            address: '',
            billingName: '',
            billingCity: '',
            billingHouse: '',
            billingAddress: '',
            billingPostcode: '',
            billingVAT: '',
            under40kg: '',
            policy: false,
            products: [],
            newProduct: {
                brand: '',
                otherBrand: '',
                model: '',
                otherModel: '',
                models: [],
                serialNumber: '',
                images: [],
                description: ''
            },
            brands: [],
            images: []
        }
    },

    mounted() {
        axios.get('/get_user_data').then(response => {
            if (response.data.user) {
                this.name = response.data.user.full_name;
                this.billingName = response.data.user.full_name;
                this.email = response.data.user.email;
            }
            if (response.data.address) {
                this.billingPostcode = response.data.address.postcode;
                this.postcode = response.data.address.postcode;
                this.billingCity = response.data.address.city;
                this.billingVAT = response.data.address.vat_id;
                this.city = response.data.address.city;
                this.billingAddress = response.data.address.address1;
                this.address = response.data.address.address1;
                this.phone = response.data.address.phone;
            }
            this.brands = response.data.brands;
            this.models = response.data.products;
            if (this.$props.product !==  '') {
                this.addProduct();
                var prod = JSON.parse(this.$props.product);
                this.products[0].brand = prod[0].brand_id;
                this.products[0].model = prod[0].id;
                this.brandSelected(this.newProduct, this.newProduct.brand);
            }
        });
    },

    methods: {
        addProduct() {
            this.newProduct = {
                brand: '',
                model: '',
                serialNumber: '',
                images: [],
                description: ''
            }
            this.products.push(this.newProduct);
        },
        deleteProduct(index) {
            this.products.splice(index, 1);
        },
        brandSelected(product, newBrand) {
            if (newBrand != 'other') {
                axios.get('/get_products', {params: {brand: newBrand}}).then(response => {
                    product.models = response.data;
                    this.$forceUpdate();
                });
            }
        },
        save() {
            if (this.products.length < 1) {
                Swal.fire({
                        title: this.$root.__('alert.error'),
                        text: this.$root.__('error_report_form.min_1_product_text'),
                        icon: 'error',
                        confirmButtonColor: '#ffb307'
                    }
                )
            }
            this.$validator.validate().then(valid =>
            {
                if (valid && this.$props.loggedin && (this.products.length > 0)) {
                    this.$root.showLoader();
                    axios.post('/hibabejelentes/mentes', {
                        name: this.name,
                        city: this.city,
                        phone: this.phone,
                        email: this.email,
                        postcode: this.postcode,
                        house: this.house,
                        address: this.address,
                        billingName: this.billingName,
                        billingCity: this.billingCity,
                        billingHouse: this.billingHouse,
                        billingAddress: this.billingAddress,
                        billingPostcode: this.billingPostcode,
                        vat_id: this.billingVAT,
                        courer: this.under40kg,
                        products: this.products,
                        images: this.images
                    }).then(response => {
                        this.$root.hideLoader();
                        if(response.status == 200 || response.status == 302){
                            /*
                            Swal.fire({
                                    title: this.$root.__('error_report_form.successful_title'),
                                    text: this.$root.__('error_report_form.successful_text'),
                                    icon: 'success',
                                    confirmButtonColor: '#ffb307'
                                }
                            )
                            */
                            //location.reload();
                            window.location.href = this.successUrl;
                        } else {
                            Swal.fire({
                                    title: this.$root.__('error_report_form.unsuccessful_title'),
                                    text: this.$root.__('error_report_form.unsuccessful_text'),
                                    icon: 'success',
                                    confirmButtonColor: '#ffb307'
                                }
                            )
                        }

                    });
                }
            })
        },
        handleImages(files, product){
            product.images = [];
            files.forEach(function (elem) {
                let file = elem;
                let reader = new FileReader();
                reader.onloadend = (file) => {
                    product.images.push(reader.result);
                }
                reader.readAsDataURL(file);
            });
        },
        login() {
            axios.post('/login', {
                email: this.email,
                password: this.password
            }).then(error => {
                if ((typeof error.response != 'undefined') && (error.response.status == 422)) {
                    Swal.fire({
                            title: __('error_report_form.login_unsuccessfull_title'),
                            text: __('error_report_form.login_unsuccessfull_text'),
                            icon: 'error',
                            confirmButtonColor: '#ffb307'
                        }

                    )
                } else {
                    location.reload();
                }
            });
        }
    }
}
</script>

<style scoped>
.title {
    text-transform: uppercase;
}
.col-6 {
    width: 100%;
}
.row {
    margin-bottom: 10px;
}
.title-row {
    margin-top: 30px;
}
label {
    font-size: 16px !important;
}
span {
    font-size: 14px !important;
}
.login-button {
    width: 50%;
    left: 25%;
    position: relative;
    background-color: #ffb307;
    color: white;
    font-weight: bold;
}
.title:after {
    content: ""; /* This is necessary for the pseudo element to work. */
    display: block; /* This will put the pseudo element on its own line. */
    width: 4%; /* Change this to whatever width you want. */
    padding-top: 10px; /* This creates some space between the element and the border. */
    border-bottom: 5px solid #ffb307; /* This creates the border. Replace black with whatever color you want. */
}
</style>
